import Link from "next/link";
import React from "react";
import { SimpleTactic, Tactic } from "@/types/tactic";
import { AcademicCapIcon, CircleStackIcon } from "@heroicons/react/24/solid";

export const TacticSimpleCard = ({
  tactic,
}: {
  tactic: SimpleTactic | Tactic;
}) => {
  return (
    <Link
      href={`/app/tactics/${tactic.id}`}
      key={tactic.id}
      className={"border rounded px-4 py-7 text-sm relative hover:opacity-60"}
    >
      <span
        className={
          "relative top-[-2px] inline-block text-[10px] font-bold bg-blue-700 text-white mr-2 py-px px-2 rounded"
        }
      >
        第{tactic.sort_order}回
      </span>
      {tactic.title}
      {tactic.is_attended && (
        <span
          className={
            "absolute top-0.5 right-2 flex text-[10px] items-center text-red-500 font-bold"
          }
        >
          <AcademicCapIcon className={"w-4 fill-red-500 mr-0.5"} />済
        </span>
      )}
      <span
        className={
          "absolute bottom-1 right-1 flex text-[10px] items-center text-gray-400 font-bold font-helvetica"
        }
      >
        <CircleStackIcon className={"w-4 fill-gray-500 mr-0.5"} />
        {tactic.experience_point}
      </span>
    </Link>
  );
};
